import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { NodeExtension, NodeGroup, toggleBlockItem, object, setBlockType, extensionDecorator } from '@remirror/core';
import { textblockTypeInputRule } from '@remirror/pm/inputrules';

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var HeadingExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    levels: [1, 2, 3, 4, 5, 6],
    defaultLevel: 1
  },
  staticKeys: ['defaultLevel', 'levels']
}), /*#__PURE__*/_dec(_class = class HeadingExtension extends NodeExtension {
  get name() {
    return 'heading';
  }

  createNodeSpec(extra) {
    return {
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        level: {
          default: this.options.defaultLevel
        }
      }),
      content: 'inline*',
      group: NodeGroup.Block,
      defining: true,
      draggable: false,
      parseDOM: this.options.levels.map(level => ({
        tag: "h".concat(level),
        getAttrs: element => _objectSpread(_objectSpread({}, extra.parse(element)), {}, {
          level
        })
      })),
      toDOM: node => {
        if (!this.options.levels.includes(node.attrs.level)) {
          // Use the first level available
          return ["h".concat(this.options.defaultLevel), extra.dom(node), 0];
        }

        return ["h".concat(node.attrs.level), extra.dom(node), 0];
      }
    };
  }

  createCommands() {
    var _this = this;

    return {
      /**
       * Toggle the heading for the current block. If you don't provide the
       * level it will use the options.defaultLevel.
       */
      toggleHeading: function toggleHeading() {
        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return toggleBlockItem({
          type: _this.type,
          toggleType: _this.store.schema.nodes.paragraph,
          attrs
        });
      }
    };
  }

  createKeymap() {
    var keys = object();
    this.options.levels.forEach(level => {
      keys["Shift-Ctrl-".concat(level)] = setBlockType(this.type, {
        level
      });
    });
    return keys;
  }

  createInputRules() {
    return this.options.levels.map(level => textblockTypeInputRule(new RegExp("^(#{1,".concat(level, "})\\s$")), this.type, () => ({
      level
    })));
  }

}) || _class);

export { HeadingExtension };
